import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import { localInshaApi, credentials } from "utils/imgApi";
import { BiEdit } from "react-icons/bi";
import AddIcon from '@material-ui/icons/Add';
import Compressor from "compressorjs";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import styleDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import styleBtn from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const style = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleDrop = makeStyles(styleDrop);
const useStyleSweet = makeStyles(styleSweet);
const useStyleBtn = makeStyles(styleBtn);

export default function UpgradePlanApps(props) {
  const [admin, setAdmin] = React.useState("");
  const [plan, setPlan] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classDrop = useStyleDrop();
  const history = useHistory();
  const classSweet = useStyleSweet();
  const classBtn = useStyleBtn();

  const { search } = useLocation();
  const a = new URLSearchParams(search).get("a");
  const title = new URLSearchParams(search).get("title");

  async function getCat() {
    const api = localInshaApi + `/admin/byId/${a ? a : "2"}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setAdmin(getResult);

    const apiPlan = localInshaApi + `/plan/list`;
    const resultPlan = await fetch(apiPlan, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResultPlan = await resultPlan.json();
    setPlan(getResultPlan.PlanList.filter((f) => f.title === title)[0]);
  }

  useEffect(() => {
    getCat();
  }, []);

  const SubmitAddImage = async () => {

    if (!plan || !plan.price) {
      alertTypeOps("danger");
      alertMsgOps("Plan not loaded properly");
      setSubmitted(true);
      return;
    }

    if (!window.Razorpay) {
      alertTypeOps("danger");
      alertMsgOps("Razorpay not loaded");
      setSubmitted(true);
      return;
    }

    setLoading(true);

    try {
      const getPriceNum = (val) => Number(String(val).replace(/,/g, ""));
      const intValue = getPriceNum(plan.price);
      const orderResponse = await fetch(`${localInshaApi}/payment/create-order`, {
        method: 'POST',
        headers: {
          Authorization: `Basic ${credentials}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: intValue * 100,
          currency: 'INR',
          receipt: 'receipt_001',
        }),
      });

      const orderData = await orderResponse.json();
      // console.log("Order Data:", orderData);

      if (!orderData || !orderData.order_id) {
        alertTypeOps("danger");
        alertMsgOps("Failed to create Razorpay order");
        return;
      }

      const options = {
        key: "rzp_live_C725eH28zc3GKC",
        amount: intValue * 100,
        currency: "INR",
        name: "INDIAN BANGLES (Manufacture)",
        description: " (Manufacture)",
        order_id: orderData.order_id,
        prefill: {
          name: `${admin.firstname} ${admin.lastname}`,
          email: admin.email,
          contact: admin.mobile,
        },
        handler: async function (response) {
          if (response.razorpay_payment_id) {
            const requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Basic ${credentials}`,
              },
              body: JSON.stringify({
                ordersId: null,
                clientId: null,
                name: admin.firstname + " " + admin.lastname,
                amount: intValue,
                received: Math.floor(intValue),
                paymentDescription: null,
                referenceId: null,
                paymentLink: response.razorpay_payment_id,
                status: "Paid",
                source: "Admin Repay Plan",
                adminId: admin.id
              })
            };

            fetch(localInshaApi + `/payment/normalAdd`, requestOptions)
              .then((res) => res.json())
              .then((res) => {
                if (res.message === "Data Inserted Successfully !!!") {
                  // console.log("Done");
                  const requestOptions = {
                    method: "PUT",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                      Authorization: `Basic ${credentials}`,
                    },
                    body: JSON.stringify({
                      webPlan: plan.title
                    })
                  };

                  fetch(localInshaApi + `/admin/updateEndDate/byMobile/${admin.mobile}`, requestOptions)
                    .then((res) => res.json())
                    .then((res) => {
                      // console.log(res);

                      if (res.message === "Data Updated Successfully !!!") {
                        // console.log("Admin");

                        alertTypeOps("success");
                        alertMsgOps("Payment Succesfully Done... Please Go back to App !!!");
                        setSubmitted(true);
                      }
                    });
                }
              });
          }
        },
        modal: {
          ondismiss: function () {
            setLoading(false);
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error(err);
      alertTypeOps("danger");
      alertMsgOps("Payment failed");
      setSubmitted(true);
      setLoading(false);
    }
  }

  const hideAlert = () => {
    setSubmitted(false);
    // history.push("admin-management://Image Option");
    history.push("/auth/login-page");
    // window.location.reload(false);
  };

  return (
    <div className={classes.container}>
      {submitted ? (
        <SweetAlert
          type={alertType}
          style={{ display: "block", marginTop: "-100px" }}
          title={alertMsg}
          onConfirm={() => hideAlert()}
          confirmBtnCssClass={
            classSweet.button + " " + classSweet.success
          }
        >
          Plan Upgrade
        </SweetAlert>
      ) : null}{" "}
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <form>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <AddIcon />
                </CardIcon>
                <h3 className={classes.cardIconTitle}>
                  <small>Plan Upgrade</small>
                </h3>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <div style={{ marginBottom: "20px" }}>
                      <h5>
                        Plan: <b> {plan?.title || "Loading..."}</b>
                      </h5>
                      <h5>
                        Price: <b> ₹ {plan?.price || "0"}</b>
                      </h5>
                      <h5>
                        User: <b>{" "}
                          {admin
                            ? `${admin.firstname || ""} ${admin.lastname || ""}`.trim()
                            : "Loading..."}</b>
                      </h5>
                    </div>
                  </GridItem>
                </GridContainer>
                <Button
                  color="rose"
                  type="button"
                  onClick={SubmitAddImage}
                  disabled={loading || !admin || !plan}
                  className={classBtn.updateProfileButton}
                >
                  {loading
                    ? "Processing..."
                    : `Pay ₹ ${Number(plan?.price || 0).toLocaleString("en-IN")}`}
                </Button>
              </CardBody>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}

UpgradePlanApps.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
